<template>
  <div>
    <myHead></myHead>
    <orderlist></orderlist>
    <div class="service">
      <p>咨询热线：4000778183</p>
      <p>(周一至周日9:00-22:00)</p>
      <p><span>客维智能科技(广州)有限公司</span></p>

    </div>
    <div class="login">
      <button @click="LoginOut"> 退出登录</button>
    </div>
  </div>
</template>
<script>
import { myHead, orderlist } from './component'

import { Dialog } from 'vant';

export default {
  components: {
    myHead,
    orderlist
  },
  methods: {
    LoginOut () {
      Dialog.confirm({
        title: '是否退出登录'
      }).then(() => {
        this.$store.dispatch('user/loginOut')
      }).catch(() => { })
    },
  }
}
</script>
<style lang="scss" scoped>
.login {
  font-size: 0.2rem;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0.5rem;
  margin-bottom: 2rem;
  padding-bottom: env(safe-area-inset-bottom);
  button {
    width: 6.5rem;
    border: none;
    padding: 0.2rem;
    background: #5a9dff;
    color: white;
    font-size: 0.3rem;
    border-radius: 30px;
  }
}

.service {
  margin: 0.3rem;
  text-align: center;
  font-size: 0.3rem;
  background: #fff;
  padding: 0.2rem;
  color: #5a9dff;
  p {
    margin: 0.1rem 0;
    span {
      font-weight: 800;
    }
  }
}
</style>
